export const registerUserService = (request) => {
  const REGISTER_API_ENDPOINT = '/service/liquidlove/signup';
  //const REGISTER_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/signup';
  
  const parameters = {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + request.user.token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.user.data)
  };

  return fetch(REGISTER_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const loginUserService = (request) => {
  
  const LOGIN_API_ENDPOINT = '/service/liquidlove/signin';
  //const LOGIN_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/signin';
  
  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }, 
    body: JSON.stringify(request.user)   
  };

  return fetch(LOGIN_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};